export default (client) => {
  return {
    fetchRows({ viewId, limit = 1000, offset = 0 }) {
      return client.get(`/database/views/keyoflife-map/${viewId}/`, {
        params: { limit, offset },
      })
    },
    geocode({ viewId, batch = 5 }) {
      return client.post(
        `/database/views/keyoflife-map/${viewId}/geocode/`,
        {},
        { params: { batch } }
      )
    },
  }
}
